(function() {
    var drawer;
    if (CartDrawer) {
      drawer = new CartDrawer();
    }

    var refreshCart = function() {
      if (drawer && drawer.refresh) {
        drawer.refresh();
      } 
    };
    
    window.addEventListener('DCART:appApi.initialized', function() {
        dcartAPI.eventBus.subscribe(dcartAPI.Events.Discount.Applied, function() {
        refreshCart();
      });
        dcartAPI.eventBus.subscribe(dcartAPI.Events.Discount.Removed, refreshCart);
    });
    
    window.addEventListener('DCART:appApi.initialized', function() {
      dcartAPI.discount.setCustomConfig({
        disableCartRefresh: true,
      });
    });
})(window);